/*
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-11-27 19:30:38
 * @LastEditors: jing
 * @LastEditTime: 2021-03-06 19:07:02
 * @Description: file content
 * 
 */
// const Mock = require('mockjs');
import baseFakeData from "./base-fake-data";
export default {
    protocol: "",
    domain: "",
    action: {
        createQrCode: {
            api: "/yq-oop/oop/common/createQrCode",
            mock: function () {
                return {
                    msg: "success",
                    code: 0,
                    data: {
                        value: "这里是假数据"
                    }
                }
            }
        },
        createQrCodeDynamic: "/yq-oop/oop/common/createQrCode/dynamic",
        smsCode: "/yq-oop/oop/common/smsCode",
        share: "/yq-oop/oop/share/share",
        participate: "/yq-oop/oop/user/participate",
        orderAdd: "/yq-oop/oop/order/add",
        orderList: "/yq-oop/oop/order/list",
        prizeList: "/yq-oop/oop/prize/list",
        orderReimburse: "/yq-oop/oop/order/reimburse/", //{id}
    },
    /**
     * 语音活动
     * https://actapi.ttrsznkj.com/yq-voice/doc.html#/default/用户相关服务/participateUsingPOST
     */
    voice: {
        common: {
            smsCode: {
                api: "/yq-voice/voice/common/smsCode",
                mode: "post"
            }
        },
        writeoff: {
            api: "/yq-voice/voice/write/off/", //{infoId}
            mode: "post"
        },
        // 参加游戏
        user: {
            charge: {
                api: "/yq-voice/voice/user/charge",
                mode: "post"
            },
            myPrize: {
                api: "/yq-voice/voice/user/myPrize",
                mode: "post"
            },
            participate: {
                api: "/yq-voice/voice/user/participate",
                mode: "post"
            },
            peopleFlag: {
                api: "/yq-voice/voice/user/peopleFlag",
                mode: "post"
            },
            peopleVoice: {
                api: "/yq-voice/voice/user/peopleVoice",
                mode: "post"
            },
            rank: {
                api: "/yq-voice/voice/user/rank",
                mode: "post",
                mock: function () {
                    return baseFakeData.userList.slice(0, 10).map((item, index) => {
                        let newItem = {
                            "headImg": item.headImg,
                            "nickName": item.nickName,
                            "openId": "",
                            "rank": index,
                            "rankCount": 0,
                            "url": ""
                        };
                        return newItem;
                    });
                }
            },
            rankPage: {
                api: "/yq-voice/voice/user/rankPage/", //{page}
                mode: "post",
            },
            peopleRank: {
                api: "/yq-voice/voice/user/peopleRank",
            },
            share: {
                api: "/yq-voice/voice/user/share",
                mode: "post"
            },
            voiceLogList: {
                api: "/yq-voice/voice/user/voiceLogList",
                mode: "post",
                mock: function () {
                    return {
                        "msg": "success",
                        "code": 0,
                        "data": [{
                            "rank": 1,
                            "openId": "oCfek1ENGkk6ODgtV8SAUTRC9OtE",
                            "nickName": "张翔",
                            "headImg": "http://thirdwx.qlogo.cn/mmopen/vi_32/DYAIOgq83erzB9UclmfbmDRyO1OBiaJqDDF4bGjM2YOSMBNGxia8XZBibZutnfQIH5bV7hfRibZPOMRK3GRm80H5Dg/132",
                            "rankCount": 4,
                            "url": "https://assets.media.rurushishi.com/wx1b2b96ed40674488p1/1832508972.mp3"
                        }, {
                            "rank": 2,
                            "openId": "oCfek1Eh1yhHYj8llHgSKThnWHTk",
                            "nickName": "砥砺",
                            "headImg": "http://thirdwx.qlogo.cn/mmopen/vi_32/Q0j4TwGTfTKWEhIJLCiaIyQUDqsaQpuJAlWpGDaSSEmn3Gtg00nwksYJaZUfCrmjw75aVh9NDpk7jE1g238icIKA/132",
                            "rankCount": 1,
                            "url": "https://assets.media.rurushishi.com/wx1b2b96ed40674488p1/472748376.mp3"
                        }, {
                            "rank": 3,
                            "openId": "oCfek1ChGQWEB_d8-S1_RmqoboDk",
                            "nickName": "Aragorn",
                            "headImg": "http://thirdwx.qlogo.cn/mmopen/vi_32/DYAIOgq83eqTYPU2fGOyibqIDZgxjjzNsibljWWRxibq5oiaJTVDbIRicF9PELr4kIQfZdvqoCKJPsKt9hVWx5a3gHg/132",
                            "rankCount": 1,
                            "url": "https://assets.media.rurushishi.com/wx1b2b96ed40674488p1/960357223.mp3"
                        }]
                    }
                }
            }
        },
        // 配置活动
        info: {
            info: {
                api: "/yq-voice/voice/info/info/", //{infoId}
                mode: "post"
            },
            init: {
                api: "/yq-voice/voice/info/init/", //{infoId}
                mode: "post"
            },
            updateInfoArea: {
                api: "/yq-voice/voice/info/updateInfoArea",
                mode: "post"
            },
        },
        text: {
            info: {
                api: "/yq-voice/voice/text/init/", //{infoId}
                mode: "post"
            },
            query: {
                api: "/yq-voice/voice/text/query/", //{infoId}/{count}
                mode: "post"
            },
        },
        game: {
            match: {
                api: "/yq-voice/voice/game/match",
                mode: "post"
            },
        },
    },
    purchase: {
        //参加游戏/yq-oop/oop/user/participate
        participate: {
            api: "/yq-bl-oop/oop/user/participate",
            mode: "post"
        },
        //获取个人订单/yq-oop/oop/order/list //通过订单的状态判断是否中奖
        orderList: {
            api: "/yq-bl-oop/oop/order/list",
            mode: "get"
        },
        //获取二维码/yq-oop/oop/common/createQrCode/dynamic 
        getQrcode: {
            api: "/xincheng-oop-voice/oop/common/createQrCode/dynamic", //openid, channel fromType=2
            mode: "get"
        },
        //分享文案 /yq-oop/oop/share/text type=1分享文案  2 海报的文案
        shareText: {
            api: '/yq-bl-oop/oop/share/text',
            mode: 'post'
        },
        //获取页面展示奖品/yq-bl-oop/oop/prize/view
        prizeView: {
            api: '/yq-bl-oop/oop/prize/view',
            mode: 'post'
        },
        //抽奖/yq-bl-oop/oop/prize/lottery
        lottery: {
            api: '/yq-bl-oop/oop/prize/lottery',
            mode: 'post'
        },
        //获取替换奖品的列表 /yq-bl-oop/oop/prize/level
        replacePrizeList: {
            api: '/yq-bl-oop/oop/prize/level',
            mode: 'post'
        },
        //获取替换的奖品/yq-bl-oop/oop/prize/level
        replacePrize: {
            api: '/yq-bl-oop/oop/prize/level/',
            mode: 'post'
        },
        //获取验证码/yq-bl-oop/oop/common/smsCode
        smsCode: {
            api: '/yq-bl-oop/oop/common/smsCode',
            mode: 'post'
        },
        //返佣列表/yq-bl-oop/oop/user/commission/list
        commissionList: {
            api: '/yq-bl-oop/oop/user/commission/list',
            mode: 'post'
        },
        paymentUrl: {
            api: '/pay/WXPayAction/paymentUrl',
            node: 'get'
        },
        //分享红包/yq-bl-oop/oop/share/share
        shareHb: {
            api: '/yq-bl-oop/oop/share/share',
            mode: 'post'
        },
        //下单 /yq-bl-oop/oop/order/add
        orderAdd: {
            api: '/yq-bl-oop/oop/order/add',
            mode: 'post'
        },
        //取消订单 /yq-bl-oop/oop/order/cancel/{id}
        orderCancel: {
            api: '/yq-bl-oop/oop/order/cancel',
            mode: 'post'
        },
        //核销 /yq-bl-oop/oop/write/off/{infoId}
        writeOff: {
            api: '/yq-bl-oop/oop/write/off',
            mode: 'post'
        }
    },
    fortune_cat: {
        // 参加游戏
        participate: {
            api: "/yq-tiger/tiger/user/participate",
            mode: "post"
        },
        //开始游戏 招财猫
        playtiger: {
            api: "/yq-tiger/tiger/user/playtiger",
            mode: "post",
        },
        //我的奖品
        myprize: {
            api: "/yq-tiger/tiger/user/myprize",
            mode: "post",
        },
        //我的助力奖品
        myprizeinfo: {
            api: "/yq-tiger/tiger/user/myprizeinfo",
            mode: "post",
        },
        // 分享
        share: {
            api: "/yq-tiger/tiger/share/share",
            mode: "post"
        }
    },

    //砍价的接口
    bargain: {
        //参加游戏/yq-standard-energy/oop/user/participate
        participate: {
            api: "/yq-standard-energy/oop/user/participate",
            mode: "post"
        },
        //获取用户信息接口/yq-standard-energy/oop/user/getUserInfo
        getUserInfo: {
            api: "/yq-standard-energy/oop/user/getUserInfo",
            mode: "post"
        },
        //个人排行榜
        personalList: {
            api: '/yq-standard-energy/assistance/personalList',
            mode: 'get'
        },
        //总排行榜/yq-standard-energy/assistance/totalList
        rankTotalList: {
            api: '/yq-standard-energy/assistance/totalList',
            mode: 'get'
        },
        //我的奖品/yq-standard-energy/oop/prize/myPrize
        myPrize: {
            api: '/yq-standard-energy/oop/prize/myPrize',
            mode: 'post'
        },
        //获取奖品列表/yq-standard-energy/oop/prize/list
        prizeList: {
            api: '/yq-standard-energy/oop/prize/list',
            mode: 'post'
        },
        //发话费/yq-standard-energy/oop/common/sendTelFare
        sendTelFare: {
            api: '/yq-standard-energy/oop/common/sendTelFare',
            mode: 'post'
        },
        //更新手机号 /yq-standard-energy/oop/user/updateMobile
        updateMobile: {
            api: '/yq-standard-energy/oop/prize/list',
            mode: 'post'
        },
        //获取个人订单/yq-oop/oop/order/list //通过订单的状态判断是否中奖
        orderList: {
            api: "/yq-standard-energy/oop/order/list",
            mode: "get"
        },
        ///yq-standard-energy/assistance/getAwesomeFriend
        getAwesomeFriend: {
            api: "/yq-standard-energy/assistance/getAwesomeFriend",
            mode: 'get'
        },
        //获取二维码/yq-oop/oop/common/createQrCode/dynamic 
        getQrcode: {
            api: "/yq-standard-energy/oop/common/createQrCode/dynamic", //openid, channel fromType=2
            mode: "get"
        },
        //分享文案 /yq-oop/oop/share/text type=1分享文案  2 海报的文案
        shareText: {
            api: '/yq-standard-energy/oop/share/text',
            mode: 'post'
        },
        //获取页面展示奖品/yq-standard-energy/oop/prize/view
        prizeView: {
            api: '/yq-standard-energy/oop/prize/view',
            mode: 'post'
        },
        //抽奖/yq-standard-energy/oop/prize/lottery
        lottery: {
            api: '/yq-standard-energy/oop/prize/lottery',
            mode: 'post'
        },
        //获取替换奖品的列表 /yq-standard-energy/oop/prize/level
        replacePrizeList: {
            api: '/yq-standard-energy/oop/prize/level',
            mode: 'post'
        },
        //获取替换的奖品/yq-standard-energy/oop/prize/level
        replacePrize: {
            api: '/yq-standard-energy/oop/prize/level/',
            mode: 'post'
        },
        //获取验证码/yq-standard-energy/oop/common/smsCode
        smsCode: {
            api: '/yq-standard-energy/oop/common/smsCode',
            mode: 'post'
        },
        //返佣列表/yq-standard-energy/oop/user/commission/list
        commissionList: {
            api: '/yq-standard-energy/oop/user/commission/list',
            mode: 'post'
        },
        paymentUrl: {
            api: '/pay/WXPayAction/paymentUrl',
            node: 'get'
        },
        //分享红包/yq-standard-energy/oop/share/share
        shareHb: {
            api: '/yq-standard-energy/oop/share/share',
            mode: 'post'
        },
        //下单 /yq-standard-energy/oop/order/add
        orderAdd: {
            api: '/yq-standard-energy/oop/order/add',
            mode: 'post'
        },
        //取消订单 /yq-standard-energy/oop/order/cancel/{id}
        orderCancel: {
            api: '/yq-standard-energy/oop/order/cancel',
            mode: 'post'
        },
        //核销 /yq-standard-energy/oop/write/off/{infoId}
        writeOff: {
            api: '/yq-standard-energy/oop/write/off',
            mode: 'post'
        }
    },


    prize_wheel: {
        // 参加游戏
        participate: {
            api: "/yq-circle/circle/user/participate",
            mode: "post"
        },
        //开始抽奖 大转盘
        playtiger: {
            api: "/yq-circle/circle/user/playluck",
            mode: "post",
        },
        //我的奖品
        myprize: {
            api: "/yq-circle/circle/user/show",
            mode: "post",
        },
        //全部奖品
        myprizeinfo: {
            api: "/yq-circle/circle/user/myprizeinfo",
            mode: "post",
        },
        // 分享
        share: {
            api: "/yq-circle/circle/share/share",
            mode: "post"
        }
    },
    fishing_game: {
        // 保存用户信息
        saveUserInfo: {
            api: "/activities/fishing/saveUserInfo",
            mode: "post"
        },
        // 获取浏览人数和活动人数
        getBrowseCount: {
            api: "/activities/fishing/getBrowseCount",
            mode: "get"
        },
        // 记录活动浏览量
        addBrowseCount: {
            api: "/activities/fishing/addBrowseCount",
            mode: "get"
        },
        // 获取游戏次数
        getGameCount: {
            api: "/activities/fishing/getGameCount",
            mode: "get"
        },
        // 减少游戏次数
        subGameCount: {
            api: "/activities/fishing/subGameCount",
            mode: "get"
        },
        // 保存分数
        savescore: {
            api: "/activities/fishing/savescore",
            mode: "get"
        },
        // 获取抽奖次数
        getDrawCount: {
            api: "/activities/fishing/getDrawCount",
            mode: "get"
        },
        // 获取奖品列表
        getPrizeInfo: {
            api: "/activities/fishing/getPrizeInfo",
            mode: "get"
        },
        // 抽奖
        getPrizeCode: {
            api: "/activities/fishing/getPrizeCode",
            mode: "get"
        },
        // 获取我的奖品
        getMyprizeInfo: {
            api: "/activities/fishing/getMyprizeInfo",
            mode: "get"
        },
        // 是否填写手机号
        isWriteMobile: {
            api: "/activities/fishing/isWriteMobile",
            mode: "get"
        },
        // 获取领奖地址
        getAddress: {
            api: "/activities/fishing/getAddress",
            mode: "get"
        },
        // 加入团队
        joinTeam: {
            api: "/activities/fishing/joinTeam",
            mode: "get"
        },
        // 插入奖品
        insertUserPrize: {
            api: "/activities/fishing/insertUserPrize",
            mode: "get"
        },
        // 助力好友
        assistanceOnece: {
            api: "/activities/fishing/assistanceOnece",
            mode: "get"
        },

        // 分享
        share: {
            api: "/activities/fishing/share",
            mode: "post"
        },


    },
    panda_game: {
        // 保存用户信息
        saveUserInfo: {
            api: "/activities/integral/saveUserInfo",
            mode: "post"
        },
        // 获取浏览人数和活动人数
        getBrowseCount: {
            api: "/activities/integral/getBrowseCount",
            mode: "get"
        },
        // 记录活动浏览量
        addBrowseCount: {
            api: "/activities/integral/addBrowseCount",
            mode: "get"
        },
        // 获取游戏次数
        getGameCount: {
            api: "/activities/integral/getGameCount",
            mode: "get"
        },
        // 减少游戏次数
        subGameCount: {
            api: "/activities/integral/subGameCount",
            mode: "get"
        },
        // 保存分数
        savescore: {
            api: "/activities/integral/savescore",
            mode: "get"
        },
        // 获取抽奖次数
        getDrawCount: {
            api: "/activities/integral/getDrawCount",
            mode: "get"
        },
        // 获取奖品列表
        getPrizeInfo: {
            api: "/activities/integral/getPrizeInfo",
            mode: "get"
        },
        // 抽奖
        getPrizeCode: {
            api: "/activities/integral/getPrizeCode",
            mode: "get"
        },
        // 获取我的奖品
        getMyprizeInfo: {
            api: "/activities/integral/getMyprizeInfo",
            mode: "get"
        },
        // 是否填写手机号
        isWriteMobile: {
            api: "/activities/integral/isWriteMobile",
            mode: "get"
        },
        // 获取领奖地址
        getAddress: {
            api: "/activities/integral/getAddress",
            mode: "get"
        },
        // 加入团队
        joinTeam: {
            api: "/activities/integral/joinTeam",
            mode: "get"
        },
        // 插入奖品
        insertUserPrize: {
            api: "/activities/integral/insertUserPrize",
            mode: "get"
        },
        // 助力好友
        assistanceOnece: {
            api: "/activities/integral/assistanceOnece",
            mode: "get"
        },

        // 分享
        share: {
            api: "/activities/integral/share",
            mode: "post"
        },
        // 生成分享的二维码
        createQrCode: {
            api: "/activities/integral/createQrCode",
            mode: "get"
        },


    },

    voice_new: {
        //参加游戏/yq-oop/oop/user/participate
        participate: {
            api: "/yq-guoxin-voice/oop/user/participate",
            mode: "post"
        },
        // 语音列表
        list: {
            api: "/yq-guoxin-voice/oop/voice/list",
            mode: "post"
        },
        // 语音对比
        match: {
            api: "/yq-guoxin-voice/oop/voice/match",
            mode: "post"
        },
        // 随机获取一条语音
        getVoiceTextInfo: {
            api: "/yq-guoxin-voice/oop/voice/getVoiceTextInfo",
            mode: "post"
        },
        // 获取页面展示奖品
        view: {
            api: "/yq-guoxin-voice/oop/prize/view",
            mode: "post"
        },
        // 获取虚拟奖品
        getVirtualPrize: {
            api: "/yq-guoxin-voice/oop/voice/getVirtualPrize",
            mode: "post"
        },
        // 抽奖
        lottery: {
            api: "/yq-guoxin-voice/oop/prize/lottery",
            mode: "post"
        },
        // 发送话费
        sendTelFare: {
            api: "/yq-guoxin-voice/oop/common/sendTelFare",
            mode: "post"
        },
        // 获取手机验证码
        smsCode: {
            api: "/yq-guoxin-voice/oop/common/smsCode",
            mode: "post"
        },
        // 领取实物奖
        receive: {
            api: "/yq-guoxin-voice/oop/prize/receive",
            mode: "post"
        },
        // 通过奖品ID获取奖品信息(含所属项目地址)
        getPrizeById: {
            api: "/yq-guoxin-voice/oop/prize/getPrizeById",
            mode: "post"
        },
        // 我的奖品(2 未兑换 3已兑换 4 已核销)
        myPrize: {
            api: "/yq-guoxin-voice/oop/prize/myPrize",
            mode: "post"
        },
        // 话费日志记录(弹出话费弹框前调用)
        logTelFare: {
            api: "/yq-guoxin-voice/oop/common/logTelFare",
            mode: "post"
        },
        // 查找用户的语音记录（匹配成功的记录）
        selectVoiceInfo: {
            api: " /yq-guoxin-voice/oop/voice/selectVoiceInfo",
            mode: "post"
        },
        // 分享
        share: {
            api: "/yq-guoxin-voice/oop/share/share",
            mode: "post"
        },
        createQrCode: {
            api: "/yq-guoxin-voice/oop/common/createQrCode",
            mode: "get"
        }
    },
    xc_voice_purchase: {
        //根据ip获取定位区域、及活动区域列表
        getLocationByIp: {
            api: "/yq-bl-oop/oop/user/getLocationByIp",
            mode: "GET"
        },
        //根据gps获取定位区域、及活动区域列表
        getLocationByGps: {
            api: "/yq-bl-oop/oop/user/getLocationByGps",
            mode: "GET"
        },
        //展示活动信息
        showActInfo: {
            api: "/yq-bl-oop/oop/info/actInfo",
            mode: "GET"
        },
        //通过奖品ID获取奖品信息
        getPrizeById: {
            api: "/yq-bl-oop/oop/prize/getPrizeById",
            mode: "GET"
        },
        //获取奖品列表
        getPrizeList: {
            api: "/yq-bl-oop/oop/prize/view",
            mode: "POST"
        },
        //查询支付成功信息
        getPaySuccess: {
            api: "/yq-bl-oop/oop/custom/getPaySuccess",
            mode: "GET"
        },
        //剩余游戏次数
        getGameCount: {
            api: "/yq-bl-oop/oop/user/gameCount",
            mode: "GET"
        },
        //抽奖
        handleLottery: {
            api: "/yq-bl-oop/oop/prize/lottery",
            mode: "POST"
        },
        //活动项目地址
        getProjectsAddress: {
            api: "/yq-bl-oop/project/projects",
            mode: "GET"
        },
        //获取手机验证码
        getSmsCode: {
            api: "/yq-bl-oop/oop/common/smsCode",
            mode: "POST"
        },
        //发送话费
        sendTelFare: {
            api: "/yq-bl-oop/oop/custom/sendTelFare",
            mode: "POST"
        },
        //返佣列表
        getCommissionList: {
            api: "/yq-bl-oop/oop/xincheng/commission/list",
            mode: "POST"
        },
        //获取可替换奖品
        getPrizeLevel: {
            api: "/yq-bl-oop/oop/prize/level",
            mode: "POST"
        },
        //分享
        share: {
            api: "/yq-bl-oop/oop/share/share",
            mode: "POST"
        },
    }
}